/* eslint-disable no-console */
import 'rxjs';
import { Observable } from 'rxjs/Observable';
import actions from '../actions';

const loadShiftEpic = (action$, store, { api }) =>
    // eslint-disable-next-line import/no-named-as-default-member
    action$.ofType(actions.SEND_SHIFT).mergeMap(action => {
        console.log(`epics ${action}`);
        console.log(action);
        return Observable.combineLatest(
            Observable.from(api.sendShift(action.payload)),
            shiftsPayload => {
                if (shiftsPayload) {
                    console.log(shiftsPayload);
                    return actions.sendShiftSuccess({
                        content: {
                            shift: shiftsPayload.data.content,
                        },
                        meta: shiftsPayload.data.meta,
                    });
                }
                return actions.sendShiftFailure('Problem sending shift');
            },
        );
    });

export default loadShiftEpic;
